import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CampaignLaunchMethod, CampaignStatus } from 'src/app/models/campaign';
import { CampaignService } from '../../../services/campaign.service';
import { LoadingOverlayService } from 'src/app/shared/loading-overlay/loading-overlay.service';

@Component({
    selector: 'app-publish-campaign-modal',
    templateUrl: './publish-campaign-modal.component.html',
    styleUrls: ['./publish-campaign-modal.component.scss']
})
export class PublishCampaignModalComponent implements OnInit {
    highlights = {
        locations: 0,
        screens: 0,
        slots: 0,
        plays: 0,
        totalImpressions: 0,
        totalReaches: 0,
        // Present only when an external provider answered.
        externalData: null,
        // Whether the figures came from the provider; the reach line keys off it.
        externalMetricsSource: false,
        budget: {
            currencyId: 1,
            currencyName: 'USD Dollar',
            currencyCode: 'USD',
            value: 0
        }
    };
    isPerSupplierChecked = false;
    isAllAtOnceChecked = true;

    isGoLiveWithApprovedChecked = true;
    isAutomaticallyPauseCampaignChecked = false;

    public constructor(
        private router: Router,
        private loadingOverlayService: LoadingOverlayService,
        private campaignService: CampaignService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if (data?.campaign.approvementPerSupplier) {
            this.isPerSupplierChecked = true;
            this.isAllAtOnceChecked = false;
        }

        if (
            data?.campaign.campaignLaunchMethod == CampaignLaunchMethod.AUTOMATICALLY_PAUSE_CAMPAIGN
        ) {
            this.isAutomaticallyPauseCampaignChecked = true;
            this.isGoLiveWithApprovedChecked = false;
        }

        if (data?.campaign.status === CampaignStatus.BEING_EDITED) {
            data.editMode = true;
        }
    }

    ngOnInit(): void {
        if (this.data != null) {
            this.getCampaignMetrics(this.data.campaign);
        }
    }

    public navigatePayment(): void {
        const launchMethod = this.isGoLiveWithApprovedChecked
            ? CampaignLaunchMethod.GO_LIVE_WITH_APPROVED
            : CampaignLaunchMethod.AUTOMATICALLY_PAUSE_CAMPAIGN;

        this.loadingOverlayService.show();

        this.campaignService
            .updateCampaignLaunchMethod(this.data.campaign._id, launchMethod)
            .subscribe(res => {
                this.loadingOverlayService.hide();
                const queryParams = {
                    approvementPerSupplier: this.isPerSupplierChecked,
                    goLiveWithApproved: this.isGoLiveWithApprovedChecked,
                    ...(this.data.previewMode && { preview: true }),
                    ...(this.data.editMode && { 'edit-mode': true })
                };
                const urlTree = this.router.createUrlTree([
                    `/campaign/complete-payment/` + this.data.campaign._id,
                    queryParams
                ]);
                this.router.navigateByUrl(urlTree);
            });
    }

    getCampaignMetrics(campaign) {
        this.campaignService.getCampaignMetrics(campaign).subscribe((resp: any) => {
            this.highlights = resp;
        });
    }

    onPerSupplierChange() {
        this.isAllAtOnceChecked = !this.isPerSupplierChecked;
    }

    onAllAtOnceChange() {
        this.isPerSupplierChecked = !this.isAllAtOnceChecked;
    }

    onGoLiveWithApproveChange() {
        this.isAutomaticallyPauseCampaignChecked = !this.isAutomaticallyPauseCampaignChecked;
    }

    onAutomaticallyPauseCampaignChange() {
        this.isGoLiveWithApprovedChecked = !this.isGoLiveWithApprovedChecked;
    }
}
